import React, { Fragment, Component } from 'react';
import {  Redirect, Link } from 'react-router-dom'
import PropTypes from 'prop-types';
import { Avatar, Button, CssBaseline, FormControl, FormControlLabel, Checkbox, Input, InputLabel, Paper, Typography, withStyles, Grid} from '@material-ui/core'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { connect } from 'react-redux'
import { signIn } from '../../store/Actions/authActions/authActions'
import LinearProgress from '@material-ui/core/LinearProgress'

import LoginBg from "../../assets/image/login_img.jpeg";

window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;

const styles = theme => ({
  outline: {
    border: '1px solid #d8d9d9',
  },
  label: {
    backgroundColor: 'white',
    padding: "0 3px"
  },
  input: {
   paddingLeft: '15px'
  },
  mainBg: {
    position: 'relative',
    width: '100%',
    height: '100%',
    minHeight: 'calc(100vh - 64px)',
    backgroundImage: `url(${LoginBg})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  loginBox: {
    position: 'relative',
    width: '100%',
    maxWidth: '400px',
    minWidth: '320px',
    display: 'block', // Fix IE 11 issue.
    paddingLeft: theme.spacing.unit * 1.5,
    paddingRight: theme.spacing.unit * 1.5,
    paddingTop: theme.spacing.unit * 6,
    paddingBottom: theme.spacing.unit * 6,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    }
  },
  paper: {
    //marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  paperInfo: {
    marginTop: theme.spacing.unit * 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'red',
    color: 'white',
    boxShadow: 'none',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif,',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    //marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
    padding: '15px',
    borderRadius: '0px'
  },
  logintop: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginBottom: '24px',
  },
  overlay: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    background: 'rgba(250, 250, 250, .75)'

  }
  
});


class LoginForm extends Component { 

  constructor(props){
    super(props);
    this.state ={
      email: '',
      password: '',
      loadingError: false,
      loading: false
    }
  }
  
  handleChange = (e) => {
    this.setState({
      [e.target.id] : e.target.value,
      loadingError: false,
      loading: false

    })
   
  }

  handleSubmit =(e)=> {
    e.preventDefault();
    this.props.signIn(this.state);
    this.setState({
      ...this.state,
      loading: true
    })

    var that = this;
    setTimeout(function(){
    // here use that
    if(that.props.authError === "Login Failed"){
          that.setState({
            loadingError: true,
            loading: false
          })
        }
    },2000);
  }
 
  handleLoginError(){

    if(this.props.authError === "Login Failed"){
      this.setState({
        loadingError: true,
        loading: false
      })
    }
  }

  render() {
   const { classes } = this.props; 
   const { userStatus } = this.props
   if(userStatus.uid) return <Redirect to="/dashboard" />

  return (
    <div className={classes.mainBg}>
      <div className={classes.overlay}></div>
    <div className={classes.loginBox}> <CssBaseline />
      <Grid className={classes.logintop}>
        
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <div style={{lineHeight:'40px', height: '40px'}}>
          <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        </div>
        

      </Grid>
      
     
      <Paper className={classes.paper}>
        
        <form className={classes.form} onSubmit={ this.handleSubmit}>
      
          <Fragment> 
              <FormControl className={classes.outline} margin="normal" required fullWidth>
                <InputLabel className={classes.label}  variant="outlined" htmlFor="email">Email Address</InputLabel>
                <Input className={classes.input}  onChange={this.handleChange}  id="email" name="email" autoComplete="email" autoFocus />
              </FormControl>
              <FormControl className={classes.outline} margin="normal" required fullWidth>
                <InputLabel className={classes.label} variant="outlined" htmlFor="password">Password</InputLabel>
                <Input className={classes.input} onChange={this.handleChange}  name="password" type="password" id="password" autoComplete="current-password" />
              </FormControl>
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Sign in
              </Button>
              <div style={{height: '20px'}}>
              { this.state.loading === true ? 
              <LinearProgress  style={{width: '100%'}}/>
              : "" 
              }
              </div>
              <Fragment>
              
                { this.state.loadingError === true ? <Paper className={classes.paperInfo}><Typography  style={{color: 'white', marginBottom: '-4px', lineHeight: 'unset'}} variant="subheading" >
          Something is wrong
        </Typography></Paper>: ''}

              </Fragment>
          </Fragment>
        </form>
        <div style={{lineHeight:'40px', height: '40px', marginTop: '24px'}}>
          <Typography component="p" variant="subtitle2">
          <Link to='/resetpassword'>Forgot password?</Link> 
        </Typography>
        </div>
      </Paper>
    </div>
    </div>
  );
}
}

LoginForm.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
  return {
     authError: state.auth.authError,
     userStatus: state.firebase.auth,
  }
}

export default withStyles(styles)(connect(mapStateToProps, {signIn})(LoginForm))
//export default withStyles(styles)(SignIn);